import { useFFContext } from '@/components/OpenFeature/hooks/useFFContext';
import { Wrapper } from '@/components/OpenFeature/Wrapper';
import { FinishedProviderSetting } from '@/components/OpenFeature/Wrapper/finishedProviderSetting';
import { Error404 } from '@/features/errors/404';
import { PaacSetting } from '@/features/paac_setting';
import {
  PLANNED_ACTUAL_AMOUNT_CHECK_FLAG,
  usePlannedActualAmountCheckFlag,
} from '@/hooks/feature_flag/usePlannedActualAmountCheckFlag';
import { OpenFeatureProvider } from '@moneyforward/user-flex-feature-hooks';
import { FC } from 'react';

const PaacSettingGate: FC = () => {
  const isEnabled = usePlannedActualAmountCheckFlag();
  return isEnabled ? <PaacSetting /> : <Error404 />;
};

const PaacSettingPage: FC = () => {
  const ffContext = useFFContext();
  return (
    <Wrapper isProto={false}>
      <OpenFeatureProvider
        pollInterval={-1}
        context={ffContext}
        domain={PLANNED_ACTUAL_AMOUNT_CHECK_FLAG}
      >
        <FinishedProviderSetting>
          <PaacSettingGate />
        </FinishedProviderSetting>
      </OpenFeatureProvider>
    </Wrapper>
  );
};

export default PaacSettingPage;
